import { z } from "zod";

export const DiscordUserSchema = z.object({
  id: z.string(),
  username: z.string(),
  avatar: z.string().nullable(),
  email: z.string().nullable(),
  verified: z.boolean().optional(),
});

export type DiscordUserSchema = z.infer<typeof DiscordUserSchema>;

export const CreateUserSchema = z.object({
  login: z.string(),
  discordUser: DiscordUserSchema,
});

export type CreateUserInput = z.infer<typeof CreateUserSchema>;
